"use client";

import React from "react";
import BrandName from "../BrandName";
import "../../css/CustomerTestimonials.css";

type Testimonial = {
  name: string;
  role: string;
  company: string;
  message: string;
};

const testimonials: Testimonial[] = [
  {
    name: "Sabine von Preyss-Friedman, MD, FACP, CMD",
    role: "Chief Medical Officer & Sr. Vice President",
    company: "Avalon Healthcare Inc.",
    message:
      "Thanks to CAREASCEND for their helpful app! This app streamlined the payment process for our Medical Directors and immeasurably improved transparency.\n\nIt is a great tool to review and guide Medical Director activities, which contributes to driving quality processes forward.",
  },
  {
    name: "Joseph Ozenne, MD",
    role: "Medical Director, Westmoreland Care & Rehab Center",
    company: "Signature HealthCARE, LLC.",
    message:
      "CAREASCEND is the perfect app for the long-term care medical director. Logging my time for meetings and other tasks is done with ease and within a matter of seconds.With my busy schedule, every second counts.\n\nThanks CAREASCEND!",
  },
  {
    name: "Ana P. Gomes DO CMS FAAFP",
    role: "New Jersey Regional Director of Medical Affairs",
    company: "Genesis Healthcare, Inc.",
    message:
      "My CAREASCEND app came in very handy during a recent state survey.Surveyor was evaluating medical director's participation at QAPI. Signed participation was missing.\n\nAdministrator shared CAREASCEND monthly reports with the surveyor and was it accepted as acknowledgment of medical director participation during the center's QAPI process.\n\nGreat outcome here!",
  },
  {
    name: "Kevin S. Henning, MD, CMD, FAAFP, FAAHPM",
    role: "Chief Medical Officer",
    company: "US Post Acute Care, LLC",
    message:
      "CAREASCEND is an outstanding solution for post-acute and long-term care medical directors. It enables accurate, on-the-go documentation while giving leadership clear visibility into physician performance.\n\nThe platform significantly improves compliance, efficiency, and overall patient care",
  },
  {
    name: "Dr. Keith Hill",
    role: "Medical Director",
    company: "Signature HealthCARE, LLC.",
    message:
      "The CAREASCEND OSHA Medical Evaluation feature is simple, intuitive, and easy to use. The streamlined questionnaires allow me to focus on what truly needs attention, making the process efficient while also helping me better understand and connect with facility staff.",
  },
  {
    name: "AMBER GENSHEIMER MSN, RN, NPD-BC",
    role: "Director of Infection Control & Quality Management",
    company: "Signature HealthCARE, LLC",
    message:
      "The respiratory protection program within the CAREASCEND platform met all of our organizational needs.\n\nIt is easy to use, supported by excellent customer service, and appreciated by end-users for having all components in one place while meeting regulatory requirements.",
  },
  {
    name: "Debra Pierce",
    role: "Chief Compliance Officer",
    company: "Avalon Health Care, Inc.",
    message:
      "CAREASCEND has proven invaluable with reviewing medical director time sheets. The medical director can input her tasks in real time for review by the administrator.\n\nThis enables the administrator to confirm that the medical director performed the task and seek clarification about the entry.\n\nVery valuable tool.",
  },
  {
    name: "MIKE EASLEY",
    role: "Chief Information Officer",
    company: "American Senior Communities",
    message:
      "CareAscend has been a great partner to American Senior Communities. Before engaging with CareAscend to help manage our Medical Director processes, our level of engagement during the billing and payment process as well as information sharing was a disjoined and manual process.\n\nToday, thanks to our partnership with CareAscend, both our Medical Director’s and our organization have complete visibility into the billing and payment processes.\n\nAdditionally, we are able to share key metrics and education with our medical directors which help drive improvement in our overall patient care.\n\nCareAscend has been a valuable partner and willing to listen to our ideas and to help them come to fruition.",
  },
  {
    name: "Joseph Montgomery",
    role: "SVP & Chief Information Officer",
    company: "Genesis HealthCare & Powerback Rehabilitation",
    message:
      "Partnering with CareAscend has truly been a game-changer for us.Their solutions revolutionized the way we manage and automate our operational workflows, but what really sets them apart is their unwavering commitment to customer focus.\n\nThe CareAscend team genuinely listens to our needs, going above and beyond to tailor their solutions and ensure they align perfectly with our goals.In a landscape where such dedication is rare among software vendors, CareAscend has proven to be more than just a provider—they've become a true partner.\n\nThe platform itself is incredibly user-friendly, enabling our team members to quickly adapt with minimal training.Its integration with our existing systems has led to significant gains in efficiency and productivity.\n\nThanks to CareAscend, we've been able to streamline critical business functions, save valuable time, and dedicate more focus to what really matters—caring for our residents.",
  },
];

type TestimonialCardProps = {
  item: Testimonial;
};

const TestimonialCard: React.FC<TestimonialCardProps> = ({ item }) => (
  <article className="testimonial-card">
    <div className="testimonial-card-header">
      <h3 className="name">{item.name}</h3>
      <p className="role">{item.role}</p>
      <p className="company">{item.company}</p>
    </div>
    <div className="testimonial-card-body">
      {item.message.split("\n\n").map((para, i) => (
        <p key={i} className="message-para">
          {para}
        </p>
      ))}
    </div>
  </article>
);

const CustomerTestimonials: React.FC = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2 className="testimonials-title">WHAT OUR CUSTOMERS SAY</h2>
        <p className="testimonials-subtitle">
          Hear from skilled nursing facility leaders who have transformed their
          operations with <BrandName variant="light" />
        </p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((item, index) => (
          <TestimonialCard key={index} item={item} />
        ))}
      </div>
    </section>
  );
};

export default CustomerTestimonials;
